export default "<div class=\"deny-pic\"></div>";